import React from 'react';

const RegistrationInfoDialog = ({ closeModal, composingLabel, registerErrorResponse }) => {
    return (
        <div className='registrationInfoDialog'>
            <h4 className='registrationInfoDialogTitle'>{composingLabel('sportOauthLabel.registrationFailureTitle', 'Registration failed')}</h4>
            <p className='registrationInfoDialogContent'>
                {composingLabel('sportOauthLabel.registrationFailureMsg', 'Registration was not successful')}
            </p>
            <div>{registerErrorResponse.data ? registerErrorResponse.data.message : registerErrorResponse.message ? registerErrorResponse.message : ''}</div>
            <button className='registrationinfoClosebtn' onClick={() => closeModal()}>
                {composingLabel('sportOauthLabel.OK', 'OK')}
            </button>
        </div>
    )
}
export default RegistrationInfoDialog


// WEBPACK FOOTER //
// ./src/main/resources/js/components/RegistrationFormComponents/RegistrationInfoFailureDialog.js